import { IAsset } from '../types';

type ImageSize = string;

export const modifyImage = (image: IAsset, size?: ImageSize) => {
  if (!image || !image.filename) return;
  const originalUrl = image.filename;
  const url = new URL(originalUrl);
  const pathParts = url.pathname.split('/');
  const folderId = pathParts[2];
  const widthAndHeight = pathParts[3];
  const imageParts = `${pathParts[4]}/${pathParts[5]}`;

  const newUrl = size
    ? `${url.origin}/f/${folderId}/${widthAndHeight}/${imageParts}/m/${size}/filters:format(webp)`
    : `${url.origin}/f/${folderId}/${widthAndHeight}/${imageParts}/m/filters:format(webp)`;
  return newUrl;
};
